// packages import
import { Box, List, ListItem, ListItemText, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { amber } from "@mui/material/colors";
import moment from "moment";
import { FC } from "react";
import { Link } from "react-router-dom";
//others
import { ExternalUserRoleRole } from "../../../../generated";
import { NOT_APPLICABLE, STANDARD_DATE_FORMAT } from "../../../constants";
import { UserTaskListingProps } from "../../../interfaceTypes";
import { activeCaseListingStyle, eventListingStyle, infoText, userTaskListingStyles } from "../../../theme/styleConstants";
import { titleize } from "../../../utils";

export const UserTaskListing: FC<UserTaskListingProps> = ({ userCaseTask }) => {
  const isEmpty = userCaseTask?.length === 0;
  const mediumViewport = useMediaQuery('(max-width:500px)');

  return (
    <Box>
      <List sx={{ ...activeCaseListingStyle, height: '278px' }}>
        {userCaseTask && userCaseTask.map((taskItem) => {
          const { task, litigation, followUpDate } = taskItem || {}
          const { id, title } = task || {}
          const { title: caseTitle, caseNumber, caseToExternalUserToExternalUserRole, id: caseId } = litigation || {}
          const client = caseToExternalUserToExternalUserRole?.find((item) => item?.externalUserToExternalUserRole?.externalUser?.externalUserRoles && item?.externalUserToExternalUserRole?.externalUser?.externalUserRoles[0]?.externalUserRole?.role === ExternalUserRoleRole.Client)?.externalUserToExternalUserRole.externalUser
          const { firstName: clientFirstName, lastName: clientLastName } = client || {}
          const clientFullName = (clientFirstName || clientLastName) ? `${clientFirstName} ${clientLastName}` : NOT_APPLICABLE
          const followUpMoment = moment(followUpDate).startOf('day');
          const todayMoment = moment().startOf('day');
          const daysDiff = followUpMoment.diff(todayMoment, 'days');
          const isToday = followUpMoment.isSame(todayMoment, 'day');

          let backgroundColor: string = amber[500];
          if (isToday) {
            backgroundColor = 'darkRed';
          } else if (daysDiff === 2) {
            backgroundColor = '#ffc107';
          } else if (daysDiff > 2) {
            backgroundColor = 'green';
          } else if (daysDiff < 0) {
            backgroundColor = 'lightGrayFive';
          }

          return (
            <ListItem key={`${id}-${title}`}
              sx={{
                ...eventListingStyle,
                backgroundColor: backgroundColor
              }}
              secondaryAction={
                <Box textAlign='right'>
                  <Typography fontWeight={500} color='white'>
                    {moment(followUpDate).format(STANDARD_DATE_FORMAT)}
                  </Typography>
                  <Link to={`/matters/matter-detail/${caseId}`} style={{ color: 'white', textDecoration: 'underline', fontSize: '14px', textAlign: 'right' }}>View case</Link>
                </Box>
              }>

              <ListItemText
                sx={{
                  flex: 'unset',
                  maxWidth: mediumViewport ? '140px' : '300px',
                  paddingLeft: '12px'
                }}
                primary={
                  <Tooltip title={titleize(title || '')} arrow>
                    <Typography fontWeight={500} color='white' component='span' display='block' noWrap>
                      {titleize(title || '')}
                    </Typography>
                  </Tooltip>
                }
                secondary={
                  <Box display='flex' alignItems='center' sx={{ color: 'white' }} component='span'>
                    <Tooltip title={caseTitle || ''} arrow>
                      <Typography fontWeight={500} fontSize='14px' color='white' component='span' noWrap>
                        <Link to={`/matters/matter-detail/${caseId}`} style={{ color: 'white' }}>{`(#${caseNumber}) `}</Link>
                        {clientFullName}
                      </Typography>
                    </Tooltip>
                  </Box>
                }
              />
            </ListItem>
          )
        })}
      </List>

      <Box display='flex' justifyContent='space-between' alignItems='center'>
        {!isEmpty &&
          <List>
            <ListItem sx={userTaskListingStyles}>
              <Box sx={{ backgroundColor: 'darkRed', ...infoText }} />Due today
            </ListItem>
            <ListItem sx={userTaskListingStyles}>
              <Box sx={{ backgroundColor: '#ffc107', ...infoText }} />Due 2 days from now
            </ListItem>
            <ListItem sx={userTaskListingStyles}>
              <Box sx={{ backgroundColor: 'green', ...infoText }} />Future due dates
            </ListItem>
            <ListItem sx={userTaskListingStyles}>
              <Box sx={{ backgroundColor: 'lightGrayFive', ...infoText }} />Expired
            </ListItem>
          </List>
        }
      </Box>
    </Box>
  )
}